import React, { ChangeEvent } from "react";

//MUI
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

// Utils
import { debounceFun } from "../utility/utils";

type Props = {
  placeholder: string;
  searchHandler: (val: string) => void;
  disableMb?: boolean;
};

const PageSearch = ({
  placeholder,
  searchHandler,
  disableMb = false,
}: Props) => {
  const changeHandler = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    searchHandler(e.target.value.trim().toLowerCase());
  };

  return (
    <Box mb={disableMb ? 0 : 2} sx={{ marginTop: "22px" }}>
      <TextField
        size="small"
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        onChange={debounceFun(changeHandler)}
        InputProps={{
          type: "search",
          startAdornment: (
            <InputAdornment position="start">
              <IconButton aria-label="search list" edge="start">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default PageSearch;
